import TeamAssignmentsPanelContainer from '../teamAssignmentsPanel/TeamAssignmentsPanelContainer'
import {isUGREnabled} from '../../../features/selectors'
import {
    getAssignedGroupIds,
    getAssignedUserIds,
    getTeamAssignmentType,
    getUserFML,
    getUserGroups,
    getUsers,
    isEditUserPanelOpened,
    isLoading,
    isUpdatingData
} from '../teamAssignmentsPanel/selectors'
import {changeTeamAssignmentsData, closeTeamAssignmentsPanel, loadTeamAssignmentsData, showCopyContent} from './actions'
import {connect} from '../../../redux/utils'
import {bindActionCreators} from 'redux'
import {getUserId, isCopyLoading, isNeedToLoadData, isPanelOpened, isShowCopyContent} from './selectors'
import {closeAllPanels} from '../../../administration/userManagement/common/actions'

class EditTeamAssignmentsPanel extends TeamAssignmentsPanelContainer {
    constructor(params) {
        super({
            additionalClass: 'editTeamAssignmentsPanel',
            ...params
        })
    }
}

export default connect(
    state => ({
        isShown: isPanelOpened(state),
        userPanelOpenedBelow: isEditUserPanelOpened(state),
        needToLoadData: isNeedToLoadData(state),
        loading: isLoading(state),
        disabled: isUpdatingData(state),

        assignedUserIds: getAssignedUserIds(state),
        assignedGroupIds: getAssignedGroupIds(state),
        users: getUsers(state),
        userGroups: getUserGroups(state),
        isUGREnabled: isUGREnabled(state),
        teamAssignmentType: getTeamAssignmentType(state),
        userFML: getUserFML(state),
        userId: getUserId(state),

        showCopyContent: isShowCopyContent(state),
        copyContentLoading: isCopyLoading(state),
    }),
    dispatch => ({
        onPanelHide: bindActionCreators(closeTeamAssignmentsPanel, dispatch),
        onCloseButtonClick: bindActionCreators(closeAllPanels, dispatch),
        changeTeamAssignments: bindActionCreators(changeTeamAssignmentsData, dispatch),
        loadTeamAssignmentsData: bindActionCreators(loadTeamAssignmentsData, dispatch),
        showCopyContent: bindActionCreators(showCopyContent, dispatch),
    })
)(EditTeamAssignmentsPanel)


// WEBPACK FOOTER //
// ./web/js/panels/user/editTeamAssignmentsPanel/EditTeamAssignmentsPanel.js